import { byteswapInplace, getCtr, getStrides } from "../util.js";
const LITTLE_ENDIAN_OS = systemIsLittleEndian();
function systemIsLittleEndian() {
    const a = new Uint32Array([0x12345678]);
    const b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return !(b[0] === 0x12);
}
function bytesPerElement(TypedArray) {
    if ("BYTES_PER_ELEMENT" in TypedArray) {
        return TypedArray.BYTES_PER_ELEMENT;
    }
    // Unicode string array is backed by a Int32Array.
    return 4;
}
export class BytesCodec {
    kind = "array_to_bytes";
    #stride;
    #TypedArray;
    #BYTES_PER_ELEMENT;
    #shape;
    #endian;
    constructor(configuration, meta) {
        this.#endian = configuration?.endian;
        this.#TypedArray = getCtr(meta.dataType);
        this.#shape = meta.shape;
        this.#stride = getStrides(meta.shape, "C");
        // TODO: fix me.
        // hack to get bytes per element since it's dynamic for string types.
        const sample = new this.#TypedArray(0);
        this.#BYTES_PER_ELEMENT = sample.BYTES_PER_ELEMENT;
    }
    static fromConfig(configuration, meta) {
        return new BytesCodec(configuration, meta);
    }
    encode(arr) {
        let bytes = new Uint8Array(arr.data.buffer);
        if (LITTLE_ENDIAN_OS && this.#endian === "big") {
            byteswapInplace(bytes, bytesPerElement(this.#TypedArray));
        }
        return bytes;
    }
    computeEncodedSize(decodedSize) {
        return decodedSize;
    }
    decode(bytes) {
        if (LITTLE_ENDIAN_OS && this.#endian === "big") {
            byteswapInplace(bytes, bytesPerElement(this.#TypedArray));
        }
        return {
            data: new this.#TypedArray(bytes.buffer, bytes.byteOffset, bytes.byteLength / this.#BYTES_PER_ELEMENT),
            shape: this.#shape,
            stride: this.#stride,
        };
    }
}
//# sourceMappingURL=bytes.js.map